import { defineComponent as _defineComponent } from 'vue'
import { cachedAsyncSvgLoader } from '@shared/lib';
    import { IconBase } from '@shared/ui';
    import Mir from '../assets/mir.svg';
    
export default /*#__PURE__*/_defineComponent({
  __name: 'MirCashbackIcon',
  setup(__props) {

    const MirIcon = cachedAsyncSvgLoader(Mir);


return { __sfc: true,MirIcon, IconBase }
}

})